/*
  MacShack header (sections/ms-header.liquid)
  - Mega menus: open on hover (with a short delay), on the keyboard button next to each item,
    and on first tap for touch screens. Escape, the scrim or moving away closes them.
  - Search panel with live results from /search/suggest.json.
  - Phone menu sheet with one page per menu item.
  - Phones: the search row tucks away when scrolling down and comes back when scrolling up.
*/
(function () {
  if (customElements.get('ms-header')) return;

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  class MsHeader extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.scrim = this.querySelector('[data-scrim]');
      this.search = this.querySelector('#msh-search');
      this.sheet = this.querySelector('#msh-sheet');
      this.items = Array.prototype.slice.call(this.querySelectorAll('.msh-nav__i'));
      this.current = null;
      this.lastFocus = null;
      this.initMenus();
      this.initSearch();
      this.initSheet();
      this.initScroll();
      var self = this;
      this.scrim.addEventListener('click', function () { self.closeAll(); });
      document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') return;
        if (!self.sheet.hidden) { self.closeSheet(); return; }
        if (!self.search.hidden) { self.closeSearch(); return; }
        if (self.current) { var b = self.current.querySelector('.msh-nv'); self.closeMenu(); if (b) b.focus(); }
      });
    }

    /* ---------- Mega menus ---------- */
    panelFor(li) { return document.getElementById(li.getAttribute('data-menu')); }
    openMenu(li) {
      if (this.current === li) return;
      this.closeMenu(true);
      this.closeSearch(true);
      var p = this.panelFor(li);
      if (!p) return;
      li.classList.add('is-open');
      li.querySelector('.msh-nv').setAttribute('aria-expanded', 'true');
      if (this._setY) this._setY();
      p.hidden = false;
      this.scrim.hidden = false;
      this.current = li;
    }
    closeMenu(keepScrim) {
      if (!this.current) return;
      var p = this.panelFor(this.current);
      this.current.classList.remove('is-open');
      this.current.querySelector('.msh-nv').setAttribute('aria-expanded', 'false');
      if (p) p.hidden = true;
      this.current = null;
      if (!keepScrim) this.scrim.hidden = true;
    }
    initMenus() {
      var self = this;
      this.items.forEach(function (li) {
        var btn = li.querySelector('.msh-nv'), p = self.panelFor(li);
        // Click (or tap, Enter, Space) opens and closes.
        btn.addEventListener('click', function (e) {
          if (self.current === li) { self.closeMenu(); return; }
          self.openMenu(li);
          // Opened from the keyboard: move into the menu.
          if (e.detail === 0) { var first = p && p.querySelector('a'); if (first) first.focus(); }
        });
        // Glide: while a menu is open, pointing at another item switches to it.
        btn.addEventListener('pointerenter', function (e) {
          if (e.pointerType === 'mouse' && self.current && self.current !== li) self.openMenu(li);
        });
      });
      // Leaving a menu with Tab closes it.
      this.querySelectorAll('.msh-mg').forEach(function (p) {
        p.addEventListener('focusout', function (e) {
          if (!e.relatedTarget) return;
          if (p.contains(e.relatedTarget) || (self.current && self.current.contains(e.relatedTarget))) return;
          self.closeMenu();
        });
      });
      // Clicking anywhere outside the header and menus closes them.
      document.addEventListener('click', function (e) {
        if (self.current && !self.contains(e.target)) self.closeMenu();
      });
      // Scrolling the page closes an open menu (scrolling inside the menu does not).
      var y0 = 0;
      window.addEventListener('scroll', function () {
        if (!self.current) { y0 = window.scrollY; return; }
        if (Math.abs(window.scrollY - y0) > 40) self.closeMenu();
      }, { passive: true });
      this._setY = function () { y0 = window.scrollY; };
    }

    /* ---------- Search ---------- */
    initSearch() {
      var self = this;
      this.input = this.search.querySelector('[data-search-input]');
      this.resHead = this.search.querySelector('[data-res-head]');
      this.resList = this.search.querySelector('[data-res-list]');
      this.resAll = this.search.querySelector('[data-res-all]');
      this.resNone = this.search.querySelector('[data-res-none]');
      this.querySelectorAll('[data-search-open]').forEach(function (b) {
        b.addEventListener('click', function () { self.openSearch(b); });
      });
      this.search.querySelector('[data-search-close]').addEventListener('click', function () { self.closeSearch(); });
      var t = null, ctrl = null;
      this.input.addEventListener('input', function () {
        clearTimeout(t);
        var q = self.input.value.trim();
        if (q.length < 2) { self.renderResults(q, []); return; }
        t = setTimeout(function () {
          if (ctrl) ctrl.abort();
          ctrl = 'AbortController' in window ? new AbortController() : null;
          var url = (self.getAttribute('data-suggest-url') || '/search/suggest') + '.json?q=' + encodeURIComponent(q) +
            '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
          fetch(url, ctrl ? { signal: ctrl.signal } : {})
            .then(function (r) { return r.json(); })
            .then(function (d) { self.renderResults(q, (d.resources && d.resources.results && d.resources.results.products) || []); })
            .catch(function () {});
        }, 180);
      });
      this.search.addEventListener('keydown', function (e) { if (e.key === 'Tab') self.trap(e, self.search); });
    }
    money(v) {
      var n = parseFloat(v); if (isNaN(n)) return '';
      var p = this.getAttribute('data-money-prefix') || 'R ';
      var w = Math.floor(n), c = Math.round((n - w) * 100);
      return p + w.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') + (c ? '.' + (c < 10 ? '0' : '') + c : '');
    }
    renderResults(q, items) {
      var self = this;
      this.resList.innerHTML = items.map(function (p) {
        var img = p.featured_image && p.featured_image.url ? '<img src="' + esc(p.featured_image.url) + (p.featured_image.url.indexOf('?') > -1 ? '&' : '?') + 'width=120" alt="" loading="lazy">' : '<span class="ph"></span>';
        var sub = p.available === false ? 'Sold out' : (/pre-owned/i.test(p.title) ? 'Pre-owned' : (p.type || ''));
        return '<li><a href="' + esc(p.url) + '">' + img + '<span><b>' + esc(p.title) + '</b><small>' + esc(sub) + '</small></span><em>' + esc(self.money(p.price)) + '</em></a></li>';
      }).join('');
      var has = items.length > 0;
      this.resHead.hidden = !has;
      this.resAll.hidden = q.length < 2;
      this.resAll.href = (this.getAttribute('data-search-url') || '/search') + '?q=' + encodeURIComponent(q) + '&type=product';
      this.resAll.textContent = 'See all results for “' + q + '” ›';
      this.resNone.hidden = !(q.length >= 2 && !has);
      this.resNone.textContent = 'No quick matches. Press Enter to search everything.';
    }
    openSearch(from) {
      this.closeMenu(true);
      this.closeSheet(true);
      this.lastFocus = from || document.activeElement;
      this.search.hidden = false;
      this.scrim.hidden = false;
      document.documentElement.classList.add('msh-locked');
      var input = this.input;
      requestAnimationFrame(function () { input.focus(); });
    }
    closeSearch(silent) {
      if (this.search.hidden) return;
      this.search.hidden = true;
      if (!silent) {
        this.scrim.hidden = true;
        document.documentElement.classList.remove('msh-locked');
        if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus();
      }
    }

    /* ---------- Phone menu ---------- */
    initSheet() {
      var self = this;
      this.querySelectorAll('[data-menu-open]').forEach(function (b) { b.addEventListener('click', function () { self.openSheet(b); }); });
      this.sheet.querySelector('[data-menu-close]').addEventListener('click', function () { self.closeSheet(); });
      this.sheet.addEventListener('click', function (e) {
        var o = e.target.closest('[data-pane-open]');
        if (o) { self.showPane(o.getAttribute('data-pane-open')); return; }
        if (e.target.closest('[data-pane-back]')) self.showPane('root');
      });
      this.sheet.addEventListener('keydown', function (e) { if (e.key === 'Tab') self.trap(e, self.sheet); });
    }
    showPane(id) {
      var prev = this._pane;
      this.sheet.querySelectorAll('[data-pane]').forEach(function (p) { p.hidden = p.getAttribute('data-pane') !== id; });
      this.sheet.querySelector('.msh-sheet__bd').scrollTop = 0;
      this._pane = id;
      var target = id === 'root'
        ? (prev && this.sheet.querySelector('[data-pane-open="' + prev + '"]'))
        : this.sheet.querySelector('[data-pane="' + id + '"] [data-pane-back]');
      if (target) target.focus();
    }
    openSheet(from) {
      this.closeSearch(true);
      this.lastFocus = from || document.activeElement;
      this.showPane('root');
      this.sheet.hidden = false;
      document.documentElement.classList.add('msh-locked');
      var c = this.sheet.querySelector('[data-menu-close]');
      requestAnimationFrame(function () { c.focus(); });
    }
    closeSheet(silent) {
      if (this.sheet.hidden) return;
      this.sheet.hidden = true;
      document.documentElement.classList.remove('msh-locked');
      if (!silent && this.lastFocus && this.lastFocus.focus) this.lastFocus.focus();
    }
    closeAll() { this.closeMenu(); this.closeSearch(); this.closeSheet(); this.scrim.hidden = true; }

    trap(e, box) {
      var f = Array.prototype.filter.call(box.querySelectorAll('a[href], button, input, [tabindex]:not([tabindex="-1"])'), function (n) { return n.offsetParent !== null && !n.disabled; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }

    /* ---------- Phones: tuck the search row away on scroll ---------- */
    initScroll() {
      // Only switch after ~30px of travel in one direction, so momentum-scroll wobble and the
      // bounce at the end of the page can't flip it back and forth.
      // Measured from the furthest point reached since the last switch, so small wobbles don't count.
      var self = this, mark = window.scrollY, ticking = false, BUF = 30;
      var small = window.matchMedia('(max-width: 1099px)');
      function set(on) { if (self.classList.contains('is-compact') !== on) self.classList.toggle('is-compact', on); mark = window.scrollY; }
      function update() {
        ticking = false;
        var y = window.scrollY;
        if (!small.matches || y < 140) { set(false); return; }
        var maxY = document.documentElement.scrollHeight - window.innerHeight;
        if (y > maxY - 2) return;
        if (self.classList.contains('is-compact')) {
          if (y > mark) mark = y; else if (mark - y > BUF) set(false);
        } else {
          if (y < mark) mark = y; else if (y - mark > BUF) set(true);
        }
      }
      window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    }
  }
  customElements.define('ms-header', MsHeader);

  /* The bag count lives in sections/ms-header-bag.liquid: point the theme's mini cart at it
     instead of the old "header" section. */
  customElements.whenDefined('mini-cart').then(function () {
    var MC = customElements.get('mini-cart');
    if (!MC || MC.prototype.__msh) return;
    MC.prototype.__msh = true;
    var orig = MC.prototype.getSectionsToRender;
    MC.prototype.getSectionsToRender = function () {
      return orig.call(this).map(function (s) {
        return s.section === 'header' ? { id: 'header', section: 'ms-header-bag', selector: '.head-slot-cart-link' } : s;
      });
    };
  });
})();
